"use client";
//#region packages/@mantine/core/src/core/styles-api/use-styles/get-class-name/get-variant-class-name/get-variant-class-name.ts
/** Returns variant className, variant is always separated from selector with `--`, for example, `tab--default` */
function getVariantClassName({ options, classes, selector, unstyled }) {
	return options?.variant && !unstyled ? classes[`${selector}--${options.variant}`] : void 0;
}
//#endregion
export { getVariantClassName };

//# sourceMappingURL=get-variant-class-name.mjs.map